export default {"src":"/_next/static/media/img-bfy-3.cfcdd8f5.svg","height":298,"width":390,"blurWidth":0,"blurHeight":0};